export default __webpack_public_path__ + "static/media/mobile.21f2dcf7.png";